import { Attachment } from '../../shared-components/models/attachment.model';
import { ProgramAndServiceDetail } from './programs-and-services-detail.model';
import { System } from '../../shared-components/System';
import { Student } from '../../shared-components/student/student.model';
import * as moment from 'moment';

export class ProgramAndService {

    // Properties
    id: number;
    Attachments: Attachment[];
    Comments: string;
    EntryDate = new Date(System.junkDateString);
    ExitDate = new Date(System.junkDateString);
    Id: number;
    ProgramAndServicesDetail: ProgramAndServiceDetail[];
    ProgramName: string;
    Sequence: number;
    ServiceName: string;
    private _sortedDetails: ProgramAndServiceDetail[];
    ProgramCodeId: number;
    ServiceCodeId: number;
    StudentId: number;
    FirstName = '';
    LastName = '';
    MiddleName = '';
    NickName = '';
    StudentNumber = '';
    EnrollmentStatus = '';
    UserHasEditPermission = false;
    UserHasDeletePermission = false;
    // Selected Student for massupdate
    Students: Student[] = [];

    checked: false;

    // Class Functions
    get hasComments(): boolean {
        return this.Comments != null && this.Comments != undefined && this.Comments.length > 0;
    }

    get hasCommentsString(): string {
        return this.hasComments ? 'Y' : '';
    }

    get hasAttachments(): boolean {
        return this.Attachments != null && this.Attachments != undefined && this.Attachments.length > 0;
    }

    get hasAttachmentsString(): string {
        return this.hasAttachments ? 'Y' : '';
    }

    get detailsBySequence(): ProgramAndServiceDetail[] {
        if (!this._sortedDetails) {
            this._sortedDetails = this.ProgramAndServicesDetail.sort((a, b) => {
                return a.Sequence - b.Sequence;
            });
        }
        return this._sortedDetails;
    }

    get entryDateChanged() {
        return !(    // There are a lot of different values that count as null...for some reason
            (
                !this.OldEntryDate
                || this.OldEntryDate.toString() == ''
                || moment(this.OldEntryDate).format('MM/DD/YYYY') == '01/01/0001'
            ) && (
                !this.EntryDate
                || this.EntryDate.toString() == ''
                || moment(this.EntryDate).format('MM/DD/YYYY') == '01/01/0001'
            )
        )
            && !(
                this.OldEntryDate
                && this.EntryDate
                && moment(this.OldEntryDate).format('MM/DD/YYYY') == moment(this.EntryDate).format('MM/DD/YYYY')
            );
    }

    get exitDateChanged() {
        return !(    // There are a lot of different values that count as null...for some reason
            (
                !this.OldExitDate
                || this.OldExitDate.toString() == ''
                || moment(this.OldExitDate).format('MM/DD/YYYY') == '01/01/0001'
            ) && (
                !this.ExitDate
                || this.ExitDate.toString() == ''
                || moment(this.ExitDate).format('MM/DD/YYYY') == '01/01/0001'
            )
        )
            && !(
                this.OldExitDate
                && this.ExitDate
                && moment(this.OldExitDate).format('MM/DD/YYYY') == moment(this.ExitDate).format('MM/DD/YYYY')
            );
    }


    // Non DTO
    OldEntryDate = new Date(System.junkDateString);
    OldExitDate = new Date(System.junkDateString);
    EntryDateBackGroungColor = '';
    ExitDateBackGroungColor = '';
    IsAttachment: string;
    IsAttachmentAsBoolean: boolean;
    StudentName: string;
    IsEdited: boolean;
}
